import {QuestsApi, Token} from "@devour/client";
import getConfig from "@/utils/getConfig";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {USE_GET_PLAYABLE_MISSIONS_KEY} from "@/hooks/missions/useGetPlayableMissions";

export function useClaimQuestReward(fullToken?: Token) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (questId: string) => {
            if (!fullToken) throw new Error("Not authenticated");
            return new QuestsApi(getConfig(fullToken)).createQuestConfigsIdClaimReward({id: questId});
        },
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: [USE_GET_PLAYABLE_MISSIONS_KEY]});
            /*
             * Onboarding/quest widgets (Scavenger Hunt via usePlayPageQuests →
             * useOnboardingCards) derive claim state from the quest-progression
             * query, NOT the playable-missions list. Without this invalidation the
             * claimed quest never refetches, so its CLAIM button stays and re-fires
             * a redundant claim (server correctly 400s "already claimed"). Matches
             * the canonical key used by useClaimMilestone / useCreateDiscordLink.
             */
            queryClient.invalidateQueries({queryKey: ["quest-progression-user"]});
        },
    });
}
